// SureBright warranty widget integration fix
document.addEventListener('DOMContentLoaded', function() {
  // Function to reorganize the product form when SureBright widget loads
  function fixSureBrightLayout() {
    const productForms = document.querySelectorAll('.product-form__buttons');
    
    productForms.forEach(form => {
      // Find the SureBright widget - it might have various class names
      const sureBrightWidget = form.querySelector(':scope > div:not(.buy-buttons):not(.product-form__error-message):not(.quantity__rules):not(.field)');
      
      if (sureBrightWidget && sureBrightWidget.querySelector('.warranty-widget, [data-surebright-widget], .extended-warranty')) {
        // Find the buy-buttons container
        const buyButtons = form.querySelector('.buy-buttons');
        
        if (buyButtons) {
          // Find the quantity selector
          const quantitySelector = buyButtons.querySelector('quantity-input');
          
          if (quantitySelector) {
            // Insert the warranty widget after the quantity selector
            quantitySelector.insertAdjacentElement('afterend', sureBrightWidget);
          } else {
            // If no inline quantity selector, insert at the beginning of buy-buttons
            buyButtons.insertAdjacentElement('afterbegin', sureBrightWidget);
          }
          
          // Add a class to identify moved widgets
          sureBrightWidget.classList.add('surebright-integrated');
        }
      }
    });
  }
  
  // Run the fix immediately
  fixSureBrightLayout();
  
  // Also run it after a delay to catch late-loading widgets
  setTimeout(fixSureBrightLayout, 1000);
  setTimeout(fixSureBrightLayout, 2000);
  
  // Watch for changes in case SureBright loads dynamically
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList?.contains('warranty-widget') || node.querySelector?.('.warranty-widget'))) {
            setTimeout(fixSureBrightLayout, 100);
          }
        });
      }
    });
  });
  
  // Observe all product forms
  document.querySelectorAll('.product-form__buttons').forEach(form => {
    observer.observe(form, { childList: true, subtree: true });
  });
});